import useDefaultFilterConfig from "./useDefaultFilterConfig";
import {usePage} from "@inertiajs/inertia-react";
import useWorldpayFilterConfig from "./useWorldpayFilterConfig";
import useUnzerFilterConfig from "./useUnzerFilterConfig";
import useAmazonLockerFilterConfig from "./useAmazonLockerFilterConfig";
import useNiuFilterConfig from "./useNiuFilterConfig";

function getHook(clientKey) {
    switch (clientKey) {
        case 'worldpay':
            return useWorldpayFilterConfig;
        case 'unzer':
            return useUnzerFilterConfig;
        case 'amazon-locker':
            return useAmazonLockerFilterConfig;
        case 'niu':
            return useNiuFilterConfig;
        default:
            return useDefaultFilterConfig
    }
}

export default function useFilterConfig() {
    const { client, } = usePage().props;
    const useHook = getHook(client.key);
    return useHook();
}
